import createDataContext from './createDataContext';
// import IdleTimer from "react-idle-timer";
// import { useHistory } from "react-router-dom";
import React, { useContext } from 'react';
import { Context as PortalContext } from './portal.context.js';

var axios = require('axios');
var qs = require('qs');

//const portalState = React.useContext(PortalContext);
var walletOnly = 0;

let queryString = window.location.search;
let params = new URLSearchParams(queryString);

if (params.has('walletOnly'))
	walletOnly = params.get('walletOnly');

const reducer = (state, action) => {
	switch (action.type) {
		case 'login':
			return {
				...state,
				...action.payload,
				authenticated: true,
				isFullAccount: true,
				loginError: false,
				validateError: false,
				loggingIn: false,
			};
		case 'validate':
			//console.log("I'M yo", action.payload);
			return {
				...state,
				...action.payload,
				authenticated: true,
				isFullAcount: false,
				validateError: false,
				loginError: false,
				loggingIn: false,
			};
		case 'logout':
			return {
				customerID: null,
				merchantID: null,
				firstName: null,
				lastName: null,
				accountNumber: null,
				email: null,
				entryDate: null,
				loggedIn: false,
				authenticated: false,
				isFullAccount: false,
				loggingIn: false,
				passwordEmailSent: false,
				loginError: false,
				validateError: false,
				modalOpen: false,
				drawerOpen: false,
				sessionID: null,
				entryDate: '',
			};
		case 'forgot_password':
			return {
				...state,
				passwordEmailSent: true,
			};
		case 'set_sessionID':
			return {
				...state,
				sessionID: action.payload,
			};
		case 'loggingIn':
			return {
				...state,
				loggingIn: action.payload,
			};
		case 'login_error':
			return {
				...state,
				loginError: true,
				loggingIn: false,
			};
		case 'validate_error':
			return {
				...state,
				validateError: true,
				loggingIn: false,
			};
		case 'set_modal_open':
			return {
				...state,
				modalOpen: action.payload,
			};
		case 'set_drawer_open':
			return {
				...state,
				drawerOpen: action.payload,
			};
		case 'clear_errors':
			return {
				...state,
				loginError: false,
				validateError: false,
			};
		default:
			return state;
	}
};

const logout =
	(dispatch, history) =>
	async ({
		sessionID,
		removeCookie,
		history,
		op,
		path,
		hydratePortal,
		queryString,
	}) => {

		try {
			const killSessionResponse = await axios({
				method: 'post',
				data: qs.stringify({
					method: 'killSession',
				}),
				withCredentials: true,
			});

			//console.log("KILL SESSION RESPONSE", killSessionResponse);

			//await removeCookie("sessionID", { path: "/" });

			dispatch({
				type: 'logout',
			});

			sessionStorage.removeItem('authenticated');
			sessionStorage.removeItem('merchant');

			history.push(`/${op}/login${queryString}`);

			hydratePortal({ op });
		} catch {
			console.log('Error logging out');
		}
	};

const login =
	(dispatch, history) =>
	async ({
		username,
		password,
		merchantID,
		history,
		reHydratePortal,
		getExternalProviderTransactions,
		op,
	}) => {
		//console.log("I'M LOGGING IN", username, merchantID);
		console.log('COOKIES', document.cookie);
		dispatch({ type: 'loggingIn', payload: true });

		try {
			const loginPortalResponse = await axios({
				method: 'post',
				data: qs.stringify({
					method: 'login',
					username: username.toLowerCase(),
					password,
					merchantID,
				}),
				withCredentials: true,
			});

			console.log('LOGIN RESPONSE', loginPortalResponse);

			if (loginPortalResponse.data.status === 1) {

				await reHydratePortal({ op });


				// if(rehyrdatePortal){
					const updateSessionResponse = await axios({
						method: 'post',
						data: qs.stringify({
							method: 'updateSession',
							data: `{"isFullAccount": true, "customer": ${JSON.stringify(
								loginPortalResponse.data
							)}}`,
						}),
						withCredentials: true,
					});

					if (updateSessionResponse.data.status === 1) {
						getExternalProviderTransactions();
						console.log('UPDATE SESSION SUCCESS');
						dispatch({
							type: 'login',
							payload: loginPortalResponse.data,
						});

						dispatch({
							type: 'set_sessionID',
							payload: updateSessionResponse.data.sessionID,
						});

						sessionStorage.setItem(
							'authenticated',
							updateSessionResponse.data.sessionID
						);

						if (typeof walletOnly != "undefined" && walletOnly == 1) {
							history.push(`/${op}/wallet?walletOnly=1`);
						} else {
							if(loginPortalResponse.data.dealerMerchant && loginPortalResponse.data.dealerMerchant == true){
								history.push(`/${op}/deals`);
							} else {
								history.push(`/${op}/invoices`);
							}
						}
					} else {
						console.log('ERROR UPDATING SESSION');
					}
				// }
			} else {
				dispatch({
					type: 'login_error',
					payload: true,
				});
			}
		} catch {
			console.log('Error logging in');
		}
	};

const forgotPassword =
	(dispatch, history) =>
	async ({ username, merchantID }) => {
		try {
			const forgotPasswordResponse = await axios({
				method: 'post',
				data: qs.stringify({
					method: 'forgotPassword',
					merchantID,
					username,
				}),
				withCredentials: true,
			});

			return forgotPasswordResponse.data.status;
		} catch {
			console.log('Error resetting password');
		}
	};

const forgotUsernameAndPassword =
	(dispatch, history) =>
	async ({ firstName, account, vinLast6, merchantID }) => {
		try {
			const forgotUsernameAndPasswordResponse = await axios({
				method: 'post',
				data: qs.stringify({
					method: 'forgotPasswordAndUsernameResetByDealInfo',
					merchantID,
					var1 :firstName,
					var2 :account,
					var3 :vinLast6
				}),
				withCredentials: true,
			});

			return forgotUsernameAndPasswordResponse.data;
		} catch {
			console.log('Error resetting password');
		}
	};

const forgotUsername =
	(dispatch, history) =>
	async ({ emailAddress, merchantID }) => {
		try {
			const forgotUsernameResponse = await axios({
				method: 'post',
				data: qs.stringify({
					method: 'forgotUsernameSendEmail',
					merchantID,
					email :emailAddress
				}),
				withCredentials: true,
			});

			return forgotUsernameResponse.data;
		} catch {
			console.log('Error resetting password');
		}
	};

const validatePasswordCode =
	(dispatch, history) =>
	async ({ resetCode }) => {
		try {
			const validatePasswordCodeResponse = await axios({
				method: 'post',
				data: qs.stringify({
					method: 'validatePasswordCode',
					resetCode,
				}),
				withCredentials: true,
			});

			console.log(
				'Validate password code response',
				validatePasswordCodeResponse
			);

			return validatePasswordCodeResponse.data.status;
		} catch {
			console.log('Error validating password code');
		}
	};

const setNewPassword =
	(dispatch, history) =>
	async ({ password, confirmPassword }) => {
		try {
			const setNewPasswordResponse = await axios({
				method: 'post',
				data: qs.stringify({
					method: 'setNewPassword',
					password,
					confirmPassword,
				}),
				withCredentials: true,
			});

			if (setNewPasswordResponse.data.status === 1) {
				return setNewPasswordResponse.data.status;
			} else {
				return {
					message: setNewPasswordResponse.data.message,
				};
			}
		} catch {
			console.log('Error setting new password');
		}
	};

const createAccount =
	(dispatch, history) =>
	async ({ email, password, username }) => {
		try {
			const createAccountResponse = await axios({
				method: 'post',
				data: qs.stringify({
					method: 'createAccount',
					email,
					password,
					username: username.toLowerCase(),
				}),
				withCredentials: true,
			});

			return createAccountResponse.data;
		} catch {
			console.log('Error creating account');
		}
	};

const validate =
	(dispatch, history) =>
	async ({ fields, merchantID, isCreateAccount, reHydratePortal, op, getExternalProviderTransactions }) => {
		dispatch({ type: 'loggingIn', payload: true });

		let data = { method: 'validate', merchantID };

		fields.map((field, index) => {
			data = {
				...data,
				[`var${index + 1}`]: field[Object.keys(field)[0]],
			};
		});

		try {
			const validatePortalResponse = await axios({
				method: 'post',
				data: qs.stringify(data),
				withCredentials: true,
			});

			if (validatePortalResponse.data.status === 1) {
				await reHydratePortal({ op });

				// if(rehyrdatePortal){
					if (isCreateAccount) {
						dispatch({ type: 'loggingIn', payload: false });
						if (validatePortalResponse.data.hasLogin) {
							return {
								status: 1,
								message:
									'You have already created an account. Please log in.',
							};
						}
						return { status: 2, message: 'Success' };
					}

					const updateSessionResponse = await axios({
						method: 'post',
						data: qs.stringify({
							method: 'updateSession',
							data: `{"isFullAccount": false, "customer": ${JSON.stringify(
								validatePortalResponse.data
							)}}`,
						}),
						withCredentials: true,
					});

					if (updateSessionResponse.data.status === 1) {

						getExternalProviderTransactions();

						console.log('UPDATE SESSION SUCCESS');
						dispatch({
							type: 'validate',
							payload: validatePortalResponse.data,
						});

						sessionStorage.setItem(
							'authenticated',
							updateSessionResponse.data.sessionID
						);


						if (typeof walletOnly != "undefined" && walletOnly == 1) {
							history.push(`/${op}/wallet?walletOnly=1`);
						} else {
							// console.log('i want to see this message.', validatePortalResponse.data);
							if(validatePortalResponse.data.dealerMerchant && validatePortalResponse.data.dealerMerchant == true){
								history.push(`/${op}/deals`);
							} else {
								history.push(`/${op}/invoices`);
							}
						}
					} else {
						console.log('ERROR UPDATING SESSION');
					}
				// }
			} else {
				dispatch({
					type: 'validate_error',
				});
				return {
					status: 0,
					message: validatePortalResponse.data.message,
				};
			}
		} catch {
			console.log('Error validating account');
			dispatch({
				type: 'validate_error',
			});
		}
	};

const getExternalProviderTransactions = (dispatch, history) => async () => {
	try {
    const response = await axios({
      method: "post",
      data: qs.stringify({ method: "getExternalProviderTransactions" }),
      withCredentials: true,
    });

    // console.log('getExternalProviderTransactions', response.data);
  } catch {
		console.log('Error getting external provider transactions');
	}
};

const getSession =
	(dispatch, history) =>
	async ({ op, queryString }) => {
		try {
			const getSessionResponse = await axios({
				method: 'post',
				data: qs.stringify({ method: 'getSession' }),
				withCredentials: true,
			});
			
			console.log('history',history);

			console.log('getSessionResponse?',getSessionResponse);
			if(typeof getSessionResponse.data !== 'undefined'){
				console.log('what is the response data?',getSessionResponse.data);
			}
			
			if (getSessionResponse.data.status === 1 ) {
				setTimeout(() => {
					console.log('timing out');
					//removeCookie("sessionID", { path: "/" });
					//dispatch({ type: "logout" });
				}, 1000000);


				// console.log('GET SESSION RESPONSE', getSessionResponse.data);

				if(getSessionResponse.data.data != ''){

					if (getSessionResponse.data.data.isFullAccount) {
						dispatch({
							type: 'login',
							payload: getSessionResponse.data.data.customer,
						});

						dispatch({
							type: 'set_sessionID',
							payload: getSessionResponse.data.sessionID,
						});
					} else {
						dispatch({
							type: 'validate',
							payload: getSessionResponse.data.data.customer,
						});
					}
				}


				//If you are on the login page but have an active session kicks you over to the invoices.
				let page = window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1)
				if( page == 'login'){
					sessionStorage.setItem(
						'authenticated',
						getSessionResponse.data.sessionID
					);

					if(getSessionResponse.data.dealerMerchant && getSessionResponse.data.dealerMerchant == true){
						history.push(`/${op}/deals`);
					} else {
						history.push(`/${op}/invoices`);
					}


					// sessionStorage.removeItem('authenticated');
					// sessionStorage.removeItem('merchant');
	
					// history.push(`/${op}/login${queryString}`);
				}

				if(page == 'invoices' && getSessionResponse.data.dealerMerchant && getSessionResponse.data.dealerMerchant == true){
					history.push(`/${op}/deals`);
				}

		
			} else {
				// console.log('session is expired');
				sessionStorage.removeItem('authenticated');
				sessionStorage.removeItem('merchant');

				if (!window.location.href.includes("optin")) {
					history.push(`/${op}/login${queryString}`);
				}
			}
		} catch(error) {
			console.log('Error getting session', error);
			if (!window.location.href.includes("optin")) {
				history.push(`/${op}/login${queryString}`);
			}
		}
	};

const checkSession =
	(dispatch, history) =>
	async ({ op, queryString }) => {
		try {
			const getSessionResponse = await axios({
				method: 'post',
				data: qs.stringify({ method: 'getSession' }),
				withCredentials: true,
			});

			console.log('scheck', getSessionResponse);

			if (getSessionResponse.data.status !== 1) {
				console.log('session is expired');
				sessionStorage.removeItem('authenticated');
				sessionStorage.removeItem('merchant');

				if (!window.location.href.includes("optin")) {
				history.push(`/${op}/login${queryString}`);
			}
				clearTimeout(window.sessionCheck);
			} else {
				console.log('Session still exists');
			}
		} catch {
			console.log('Error checking session');
		}
	};

const setDrawerOpen = (dispatch, history) => (open) => {
	dispatch({ type: 'set_drawer_open', payload: open });
};

const clearErrors = (dispatch, history) => () => {
	dispatch({ type: 'clear_errors', payload: null });
};

export const { Provider, Context } = createDataContext(
	reducer,
	{
		login,
		validate,
		logout,
		forgotPassword,
		forgotUsernameAndPassword,
		forgotUsername,
		validatePasswordCode,
		createAccount,
		getSession,
		setDrawerOpen,
		checkSession,
		setNewPassword,
		clearErrors,
	},
	{
		customerID: null,
		merchantID: null,
		dealerMerchant: null,
		firstName: null,
		lastName: null,
		accountNumber: null,
		email: null,
		entryDate: null,
		loggedIn: false,
		authenticated: false,
		isFullAccount: false,
		loggingIn: false,
		passwordEmailSent: false,
		loginError: false,
		validateError: false,
		modalOpen: false,
		drawerOpen: false,
		sessionID: null,
		entryDate: null,
	}
);
